import React from 'react';
import { SimpleGrid } from '@chakra-ui/react';

import Typography from '../Typography';

import { Flex } from '../UI/Flex';

import DoctorIcon from '../Icons/DoctorIcon';
import UserIcon from '../Icons/UserIcon';

import { useIsMobile } from 'src/helpers/useIsMobile';

import { SidebarButton } from './SidebarButton';

interface SidebarProps {
  onClose?(): void;
}

export const SIDE_BAR_WIDTH = '190px';

export function AssistantRoutesMenu(props: SidebarProps) {
  const isMobile = useIsMobile();

  const iconWidth = isMobile ? 40 : 20;

  return (
    <>
      <SimpleGrid w={'full'} columns={1} spacing={'10px'}>
        <SidebarButton pathTo="/assistente/gerenciar-pacientes">
          <Flex mr={'10px'} mb={0}>
            <UserIcon variantColor="notification.success" width={iconWidth} />
          </Flex>
          <Typography
            whiteSpace={'pre-wrap'}
            model={'body'}
            size={'normal'}
            textAlign={isMobile ? 'center' : 'left'}
            weight="bold"
          >
            Cadastro Pacientes
          </Typography>
        </SidebarButton>

        <SidebarButton pathTo="/assistente/meus-dados">
          <Flex mr={'10px'} mb={0}>
            <DoctorIcon variantColor="support.blue" width={iconWidth} />
          </Flex>
          <Typography model={'body'} size={'normal'} textAlign={isMobile ? 'center' : 'left'} weight="bold">
            Meus dados
          </Typography>
        </SidebarButton>
      </SimpleGrid>
    </>
  );
}
